
import { RevButtonTiny } from '@ds/components/ButtonTiny'
import { IconThumbsDownFilled } from '@ds/icons/IconThumbsDownFilled'
import { IconThumbsDownOutlined } from '@ds/icons/IconThumbsDownOutlined'
import { IconThumbsUpFilled } from '@ds/icons/IconThumbsUpFilled'
import { IconThumbsUpOutlined } from '@ds/icons/IconThumbsUpOutlined'

import { buyingGuideVote } from '@http/endpoints'

import translations from './Vote.translations'

export default {
  components: {
    RevButtonTiny,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    upVotes: {
      type: Number,
      required: true,
    },
    downVotes: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      iconUp: IconThumbsUpOutlined,
      iconDown: IconThumbsDownOutlined,
      iconUpFilled: IconThumbsUpFilled,
      iconDownFilled: IconThumbsDownFilled,
      votedUp: false,
      votedDown: false,
    }
  },
  computed: {
    translations: () => translations,
    upVoteWording() {
      return this.upVotes || this.downVotes
        ? `${this.upVotes}%`
        : this.$t(translations.yes)
    },
    downVoteWording() {
      return this.downVotes || this.upVotes
        ? `${this.downVotes}%`
        : this.$t(translations.no)
    },
    voted() {
      return this.votedUp || this.votedDown
    },
    upVoteIcon() {
      return this.votedUp ? this.iconUpFilled : this.iconUp
    },
    downVoteIcon() {
      return this.votedDown ? this.iconDownFilled : this.iconDown
    },
  },
  methods: {
    voteUp() {
      if (!this.voted) {
        this.vote('up-vote')
        this.votedUp = true
      }
    },
    voteDown() {
      if (!this.voted) {
        this.vote('down-vote')
        this.votedDown = true
      }
    },
    async vote(value) {
      try {
        this.loading = true
        const { payload } = await this.$store.dispatch('http/request', {
          request: buyingGuideVote,
          pathParams: {
            id: this.id,
            value,
          },
        })
        this.$emit('voted', {
          upVotes: payload.upVotes,
          downVotes: payload.downVotes,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
